<template>
  <div class="auth-form">
    <img
      class="mt-3 mb-2"
      :src="asset('imgs/zuulOS.png')"
      alt="Zuul Logo"
      width="100"
      height="23"
    />
    <hr />
    <b-form
      @submit.prevent="onRecoverPassword"
      @keyup.enter="onRecoverPassword"
    >
      <h1 class="mt-2 mb-4">
        {{ success ? 'Password reset!' : 'Reset password?' }}
      </h1>
      <error-alert :errors="errors" class="mb-4" />
      <div v-if="success">
        Your password has been reset.
        <router-link to="/login" class="link--ordinary">Sign in</router-link> to
        continue.
      </div>
      <div v-else>
        <b-form-input
          v-model="email"
          type="email"
          required
          class="base-input mb-3"
          placeholder="Email address"
          autofocus
        />
        <div class="password-input mb-3" data-recording-ignore="mask">
          <b-form-input
            v-model="password"
            required
            class="base-input mb-2"
            :type="showPassword ? 'text' : 'password'"
            placeholder="Password"
            autocomplete="off"
          />
          <button
            type="button"
            class="btn btn-link link-black"
            @click.prevent="onPasswordShow"
          >
            <span class="icon">
              <img
                v-if="showPassword"
                :src="asset('/imgs/icons/show.png')"
                alt="show"
                title="Show"
              />
              <img
                v-else
                :src="asset('/imgs/icons/hide.png')"
                alt="Hide"
                title="Hide"
              />
            </span>
          </button>
        </div>
        <div class="password-input mb-3" data-recording-ignore="mask">
          <b-form-input
            v-model="passwordConfirm"
            required
            class="base-input mb-2"
            :type="showPasswordConfirm ? 'text' : 'password'"
            placeholder="Password Confirm"
            autocomplete="off"
          />
          <button
            type="button"
            class="btn btn-link link-black"
            @click.prevent="onPasswordConfirmShow"
          >
            <span class="icon">
              <img
                v-if="showPasswordConfirm"
                :src="asset('/imgs/icons/show.png')"
                alt="show"
                title="Show"
              />
              <img
                v-else
                :src="asset('/imgs/icons/hide.png')"
                alt="Hide"
                title="Hide"
              />
            </span>
          </button>
        </div>
        <b-button variant="primary" type="submit" class="w-100">
          <template v-if="loading">
            <button-loader />
          </template>
          <template v-else>Send instructions</template>
        </b-button>
      </div>
    </b-form>
  </div>
</template>

<script>
import ButtonLoader from '../../components/ButtonLoader';
import ErrorAlert from '../../components/ErrorAlert.vue';
import SessionAPI from '../../services/SessionAPI';

export default {
  name: 'ForgotPasswordPage',
  components: {
    ButtonLoader,
    ErrorAlert,
  },
  data() {
    return {
      success: false,
      errors: {},
      loading: false,
      email: null,
      password: null,
      passwordConfirm: null,
      showPassword: false,
      showPasswordConfirm: false,
    };
  },
  methods: {
    onPasswordShow() {
      this.showPassword = !this.showPassword;
    },
    onPasswordConfirmShow() {
      this.showPasswordConfirm = !this.showPasswordConfirm;
    },
    onRecoverPassword() {
      if (this.loading) {
        return;
      }

      this.loading = true;

      SessionAPI.resetPassword(
        this.$route.params.token,
        this.email,
        this.password,
        this.passwordConfirm
      ).then((response) => {
        this.loading = false;

        if ('errors' in response) {
          debugger;
          this.errors = response.errors;
        } else {
          this.success = true;
          this.errors = {};
          this.email = null;
          this.password = null;
          this.passwordConfirm = null;
        }
      });
    },
  },
};
</script>
